export function getOS(UA) {
  let os = 'unspecified'
  let ua = UA || ''

  if (!process.env.BROWSER) {
    ua = UA.toLowerCase()
  } else {
    ua = (UA || window.navigator.userAgent).toLowerCase()
  }

  if (ua.indexOf('android') !== -1) {
    os = 'Android'
  } else if (
    ua.indexOf('iphone') !== -1
    || ua.indexOf('ipad') !== -1
    || ua.indexOf('ipod') !== -1
  ) {
    os = 'iOS'
  } else if (ua.indexOf('macintosh') !== -1) {
    os = 'Mac OS'
  } else if (ua.indexOf('windows') !== -1) {
    os = 'Windows'
  } else if (ua.indexOf('linux') !== -1) {
    os = 'Linux'
  }

  // iOS App resources embeded
  if (os === 'unspecified' && ua.indexOf('discover') >= 0) {
    os = 'iOS'
  }

  return os
}

// test on iOS 9.0+
export function getOSVersion(UA) {
  const defaultValue = {
    major: 0,
    minor: 0,
    patch: 0,
  }

  if (process.env.BROWSER) {
    UA = UA || window.navigator.userAgent // eslint-disable-line no-param-reassign
  }

  const os = getOS(UA)
  let result
  const version = {}

  if (os === 'iOS') {
    const REGEXP = /(?:iPhone OS |OS |Version\/)(\d+)[._](\d+)[._]?(\d+)?/

    result = REGEXP.exec(UA)
  } else if (os === 'Android') {
    const REGEXP = /Android\s(\d+)\.(\d+)\.?(\d+)?/

    result = REGEXP.exec(UA)
  }

  if (result) {
    version.major = parseInt(result[1], 10)
    version.minor = parseInt(result[2], 10)

    if (result[3] !== undefined) {
      version.patch = parseInt(result[3], 10)
    }

    return version
  }

  return defaultValue
}

const IPHONE_X_HEIGHT = 812
const IPHONE_XMAX_XR_HEIGHT = 896
const IPHONE_12_SERIES = [780, 844, 926]

// https://www.paintcodeapp.com/news/ultimate-guide-to-iphone-resolutions
export function iphoneXCheck(os) {
  const result = {
    isIphoneX: false,
    iphoneXType: '',
  }

  if (!process.env.BROWSER || os !== 'iOS') {
    return result
  }

  if (window.screen.height === IPHONE_X_HEIGHT) {
    result.iphoneXType = 'X'
  } else if (window.screen.height === IPHONE_XMAX_XR_HEIGHT) {
    result.iphoneXType = window.devicePixelRatio > 2 ? 'XS Max' : 'XR'
  } else if (IPHONE_12_SERIES.includes(window.screen.height)) {
    result.iphoneXType = window.devicePixelRatio === 3 ? '12' : ''
  }

  if (result.iphoneXType) {
    result.isIphoneX = true
  }

  return result
}

export function iphoneXCheckNode({ os, userAgent }) {
  const result = {
    isIphoneX: false,
    iphoneXType: '',
  }

  if (os !== 'iOS' || !userAgent) {
    return result
  }

  const ua = userAgent.toLowerCase()

  // 屏幕倍率
  let screenScale = ua.match(/scale\/(\d+)/)?.[1] || 1
  screenScale = parseInt(`${screenScale}`, 10)
  // 屏幕高度
  const screenHeight = (ua.match(/resolution\/(\d+)\*(\d+)/)?.[2] || 0) / screenScale
  // 屏幕宽度
  const screenWidth = (ua.match(/resolution\/(\d+)\*(\d+)/)?.[1] || 0) / screenScale

  if (screenHeight === IPHONE_X_HEIGHT) {
    result.iphoneXType = 'X'
  } else if (screenHeight === IPHONE_XMAX_XR_HEIGHT) {
    result.iphoneXType = screenScale > 2 ? 'XS Max' : 'XR'
  } else if (IPHONE_12_SERIES.includes(screenHeight)) {
    result.iphoneXType = screenScale === 3 ? '12' : ''
  }

  if (result.iphoneXType) {
    result.isIphoneX = true
  }

  result.screenScale = screenScale
  result.screenHeight = screenHeight
  result.screenWidth = screenWidth

  return result
}
